  import myPic from "../Assets/prajwal-kabbur.jpeg";

  export const profile = {
    name: "Prajwal Kabbur",
    titles: ["Software Engineer", "Full Stack Developer", "DevOps Enthusiast"],
    bio: [
      "I specialize in architecting cloud-native applications powered by Java, Spring Boot, and microservices.",
      "With hands-on experience in AWS cloud technologies and DevOps automation, I build solutions that are resilient, maintainable, and production-ready. I complement this backend expertise with Angular development to create seamless, end-to-end user experiences.",
      "Passionate about solving complex challenges in fast-paced, collaborative environments. Ready to build something exceptional together",
    ],
    image: myPic,
    social: {
      email: "prajwalskabbur@gmail.com",
      linkedin: "https://linkedin.com/in/prajwal-kabbur",
      github: "https://github.com/PRAJWAL-KABBUR",
      leetcode: "https://leetcode.com/u/prajwal_kabbur/"
      
    },
  };
